import { useEffect, useState } from 'react'
import { useBlocker } from 'react-router-dom'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

export const useBlockNavigation = (shouldBlock = true) => {
    const blocker = useBlocker(({ nextLocation }) => {
        // Don't block navigation to payment, order, and force-rating routes
        const allowedPaths = ['/payment', '/order', '/force-rating', '/membership/auth']
        if (allowedPaths.some(path => nextLocation.pathname.includes(path))) {
            return false
        }
        return shouldBlock
    })
    const [showModal, setShowModal] = useState(false)
    const message = 'Before leaving, you will lose your current selections. Are you sure you want to leave?'

    // Handle browser/mobile back button
    useEffect(() => {
        if (blocker.state === 'blocked') {
            setShowModal(true)
        }
    }, [blocker])

    const handleConfirm = () => {
        setShowModal(false)
        blocker.proceed()
    }

    const handleCancel = () => {
        setShowModal(false)
        blocker.reset()
    }

    // Handle browser refresh/close
    useEffect(() => {
        const handleBeforeUnload = e => {
            if (shouldBlock) {
                e.preventDefault()
                e.returnValue = message
                return message
            }
        }

        window.addEventListener('beforeunload', handleBeforeUnload)
        return () => window.removeEventListener('beforeunload', handleBeforeUnload)
    }, [shouldBlock, message])

    return (
        <Modal isOpen={showModal} toggle={handleCancel}>
            <ModalHeader toggle={handleCancel}>Leave Page?</ModalHeader>
            <ModalBody>{message}</ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button color="primary" onClick={handleConfirm}>
                    Leave
                </Button>
            </ModalFooter>
        </Modal>
    )
}
